import {RenderImageBox} from "./helpers/helpersImage";

export function multiUpload(selectorOrElement, options){
    let mode;
    let $element;

    // Проверка, является ли target строкой (селектором) или уже элементом
    if (typeof selectorOrElement === 'string') {
        $element = $(selectorOrElement);
    } else if (selectorOrElement instanceof jQuery) {
        $element = selectorOrElement;
    } else {
        $element = $(selectorOrElement);
    }

    let opts = {
        size: 'org',
        attachmentsContainer: null,
        waitText: 'Please wait',
        rules: {},
        onLoadFile: null,
        onRemoveFile: null
    };

    Object.assign(opts, options);

    let res_size = opts.size;
    let rules = opts.rules;

    let renderImageBox = function(file){

        let ImageBox = new RenderImageBox(file, res_size);
        let box = ImageBox.getBox();

        box.on('onRemove', function(e, f){
            if(opts.onRemoveFile){
                opts.onRemoveFile(f);
            }
        })

        return box;

    }

    if(opts.images && opts.images.length > 0){
        opts.images.forEach(image => {
            let box = renderImageBox(image, res_size);
            opts.attachmentsContainer.prepend(box);
        })
    }

    $element.liteUploader({

        script: '/ajax/uploadImages',
        rules: {
            allowedFileTypes: "image/jpeg,image/png,image/gif,image/heic"
        },
        singleFileUploads: true

    }).on('lu:before', function(e, files){

        for(const [key] of Object.entries(files)){
            files[key].data = {
                id: "_" + Math.ceil(Math.random() * 100000000),
                progress: 0,
                render: function(){
                    let please_wait = opts.waitText ? '<div class="please_wait">'+opts.waitText+'</div>' : '';
                    return '<div class="image_box processing_image" id="'+this.id+'">' + LoaderBox.render() + please_wait + '<div class="progress"><div class="load_line" style="width:'+this.progress+'%;"></div></div></div>'
                },
                remove: function(){
                    document.getElementById(this.id).remove();
                }
            }

            if(opts.attachmentsContainer){
                opts.attachmentsContainer.prepend($(files[key].data.render()));
            }else{
                $(this).closest('.file_upload_btn').before();
            }

        }
        mode = this.dataset.mode;
        $(this).data("liteUploader").addParam("mode", mode);

    }).on('lu:progress', function (e, state){

        state.files[0].data.progress = state.percentage;
        let box = document.querySelector('#' + state.files[0].data.id);
        if(box === null){
            box = e.target.closest('div').querySelector('.progress');
        }
        box.querySelector(".load_line").style.width = state.percentage+"%";
        if(state.percentage === 100){
            let loader = box.querySelector(".loaderbox")
            if(loader) loader.style.display = 'block';
            let wait = box.querySelector(".please_wait");
            if(wait) wait.style.display = 'block';
            let progress = box.querySelector(".progress");
            if(progress) progress.style.display = 'none';
        }

    }).on("lu:errors", function (e, errors){

        $.each(errors, function(key, val){
            $.each(val.errors, function(k, v){
                if(v.type === 'type'){
                    notice('The file "' + val.name + '" has an incorrect format. Allowed: jpg, png, gif, heic', {color: 'red'});
                }
            });
        });

    }).on('lu:success', function(e, response){

        let data;
        try{
            let resp = JSON.parse(response);
            data = resp.data;
        }catch(e){
            window.alert('Error!');
            return;
        }

        let isErrorOccurred = false;
        try{

            if(typeof data.errors !== undefined && data.errors){
                if(data.errors.length > 0){
                    $.each(data.errors, function (key, val){
                        window.notice(val['error'], {color: 'red'});
                    });
                    isErrorOccurred = true;
                }
            }else if(typeof data.error !== undefined && data.error){
                window.notice(data.error.error_msg, {color: 'red'});
                isErrorOccurred = true;
            }

        }catch(e){
            isErrorOccurred = true;
        }

        if(isErrorOccurred){
            Object.values(this.files).forEach(function(f){
                if(f.data.progress === 100){
                    f.data.progress = 0;
                    $('#' + f.data.id).remove();
                }
            });
        }

        if(typeof data.files !== undefined && data.files && data.files.length > 0){
            let file = data.files[0];

            let size = file.sizes.find(size => size.type === 'image_' + res_size);

            if(size){

                try{
                    Object.values(this.files).forEach(function(f){
                        if(f.data.progress === 100){
                            f.data.progress = 0;

                            let box = renderImageBox(file, res_size);

                            $('#' + f.data.id).replaceWith(box);
                            if(opts.onLoadFile){
                                opts.onLoadFile(file);
                            }
                            throw 'Exception';
                        }
                    });
                }catch(e){

                }

            }else{
                console.error("Err default size");
            }

            $("#sortable").sortable().disableSelection();

        }
    });

    $element.change(function(){
        if(this.files.length === 0) return;
        if(rules.max_files !== undefined){
            if(this.files.length <= rules.max_files){
                $(this).data('liteUploader').startUpload();
            }else{
                notice("Max files " + rules.max_files, {color: 'red'})
            }
        }else{
            $(this).data('liteUploader').startUpload();
        }
    });

}

export function singleUpload(box, res_size, callback, callbackProgress){

    let mode;
    let progress;
    let loadLine;

    // Сделал параметр name необяательным, потому что при FormData в него складываются выбранные файлы
    let ref = $(box).attr('name');

    $(box).liteUploader({

        script: '/ajax/uploadImages',
        ref: ref || 'filesUpload[]',
        rules: {
            allowedFileTypes: "image/jpeg,image/png,image/gif,image/heic"
        },
        singleFileUploads: true

    }).on('lu:before', function(e, files){

        files[0].data = {progress: 0}

        mode = this.dataset.mode;
        $(this).data("liteUploader").addParam("mode", mode);

        progress = document.createElement('div');
        progress.classList.add('progress');

        loadLine = document.createElement('div');
        loadLine.classList.add('load_line');

        progress.appendChild(loadLine);

        if(!callbackProgress) $(this).closest('div').prepend(progress);

    }).on('lu:progress', function (e, state){

        state.files[0].data.progress = state.percentage;

        if(callbackProgress){
            callbackProgress(state.percentage);
        }else{
            loadLine.style.width = state.percentage+"%";

            progress.querySelector(".load_line").style.width = state.percentage+"%";
            if(state.percentage === 100){
                setTimeout(function(){
                    progress.remove();
                }, 500);
            }
        }



    }).on("lu:errors", function (e, errors){

        $.each(errors, function(key, val){
            $.each(val.errors, function(k, v){
                if(v.type === 'type'){
                    notice('The file "' + val.name + '" has an incorrect format. Allowed: jpg, png, gif, heic', {color: 'red'});
                }
            });
        });

    }).on('lu:success', function(e, response){

        let data;
        try{
            let resp = JSON.parse(response);
            data = resp.data;
        }catch(e){
            window.alert('Error!');
            return;
        }

        if(typeof data.errors !== undefined && data.errors){
            if(data.errors.length > 0){
                $.each(data.errors, function (key, val) {
                    notice(val['error'], {color: 'red'});
                });
            }
        }else if(typeof data.error !== undefined && data.error){
            notice(data.error.error_msg, {color: 'red'});
        }

        if(typeof data.files !== undefined && data.files && data.files.length > 0){
            let file = data.files[0];
            file.sizes.forEach(size => {
                if(size.type === 'image_' + res_size){
                    callback($(this), size.url, file.key, file);
                }
            });
        }

    });

    $(box).change(function(){
        $(this).data('liteUploader').startUpload();
    });

}